<template>
  <nav>
    <ul class="flex w-full mr-0 sm:w-auto sm:mr-auto">
      <slot></slot>
    </ul>
  </nav>
</template>
